module.exports = __webpack_public_path__ + "img/solitarnoy_kostnoy_kisty0.ff05e979.png";